import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { Fragment, PureComponent } from 'react';
import styles from './requestSimulatorFold.module.scss';
export class RequestSimulatorFold extends PureComponent {
    constructor(props) {
        super(props);
        this.name = 'RequestSimulatorFold';
        this.state = {
            folded: props.folded,
        };
        this.toggleFold = this.toggleFold.bind(this);
    }
    toggleFold() {
        const { folded } = this.state;
        this.setState({ folded: !folded });
    }
    render() {
        const { className, foldKey, isArray, isLastLine, children } = this.props;
        const { folded } = this.state;
        const braces = isArray ? ['[', ']'] : ['{', '}'];
        const name = foldKey ? `${foldKey}:` : '';
        const rootClass = classnames({
            [styles.root]: true,
        }, className);
        const endBrace = `${braces[1]}${isLastLine ? '' : ','}`;
        return (_jsxs("div", Object.assign({ className: rootClass }, { children: [_jsx("div", Object.assign({ className: styles.clearFloat }, { children: _jsxs("button", Object.assign({ type: "button", onClick: this.toggleFold, className: styles.toggle }, { children: [_jsx("span", Object.assign({ className: styles.toggleIcon }, { children: _jsx(Icon, { name: folded ? 'plus' : 'minus' }) })), _jsxs("span", Object.assign({ className: styles.objectStart }, { children: [`${name} ${braces[0]}`, !!folded && (_jsxs(Fragment, { children: [_jsx("span", Object.assign({ className: styles.dots }, { children: "\u2026" })), endBrace] }))] }))] })) })), !folded && (_jsxs(Fragment, { children: [!!children && _jsx("div", Object.assign({ className: styles.indented }, { children: children })), _jsx("div", Object.assign({ className: styles.clearFloat }, { children: endBrace }))] }))] })));
    }
}
